import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import aiAviatorLogo from "../../assets/AIAviatorLogo/ai-aviator-logo.svg";

export default function Header() {
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  // const navLinks = useRef([]);
  const desktopNavLinks = useRef([]);
  const mobileNavLinks = useRef([]);
  const [ids] = useState({
    About: "one",
    Solution: "two",
    ROI: "three",
    Features: "four",
    Benefits: "five",
    FAQ: "six",
  });
  const scrollToSection = (id) => {
    const headerOffset = 100; // Adjust for fixed header height
    const sectionElement = document.getElementById(id);
    const elementPosition = sectionElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      setIsMenuActive(false);
    }
  };
  useEffect(() => {
    if (isMenuActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuActive]);

  const handleScroll = () => {
    const isScrolled = window.scrollY > 0;
    setIsHeaderActive((prev) => {
      if (prev !== isScrolled) {
        return isScrolled; // Only update state if there's a transition
      }
      return prev; // Avoid unnecessary state updates
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    handleScroll(); // To set initial state on mount
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        const mobileHamburger = document.querySelector(".mobile-hamburger");
        const mainMenu = document.querySelector(".mobile-menu");

        if (mobileHamburger) {
          mobileHamburger.classList.remove("is-activeHamburger");
        }
        if (mainMenu) {
          mainMenu.classList.remove("mobile-menu-active");
        }
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const updateLinkState = (links) => {
            const link = links.find(
              (link) => link.dataset.target === entry.target.id
            );
            if (link) {
              if (entry.isIntersecting) {
                link.classList.add("redirection-active");
              } else {
                link.classList.remove("redirection-active");
              }
            }
          };

          updateLinkState(desktopNavLinks.current);
          updateLinkState(mobileNavLinks.current);
        });
      },
      { threshold: [0.4] }
    );

    const observeLinks = (links) => {
      links.forEach((link) => {
        if (!link) return;
        const sectionId = link.dataset.target;
        const sectionElement = document.getElementById(sectionId);
        if (sectionElement) observer.observe(sectionElement);
      });
    };

    observeLinks(desktopNavLinks.current);
    observeLinks(mobileNavLinks.current);

    return () => observer.disconnect();
  }, []);

  return (
    <header className={`header ${isHeaderActive ? "active" : ""}`}>
      <div className="container">
        <nav>
          <div className="agent-pixel-logo" onClick={scrollToTop}>
            <img src={aiAviatorLogo} alt="ai-aviator-logo" />
          </div>
          <ul className="nav-ul" ref={menuRef}>
            {["About", "Solution", "ROI", "Features", "Benefits", "FAQ"].map(
              (item, index) => (
                <li
                  key={index}
                  className="nav-li-hover-element"
                  tabIndex={index}
                >
                  <a
                    href={`#${ids[item]}`}
                    data-target={ids[item]}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(ids[item]);
                    }}
                    ref={(el) => el && desktopNavLinks.current.push(el)}
                  >
                    <p className="nav-li-item">{item}</p>
                  </a>
                </li>
              )
            )}
          </ul>
        </nav>
        <div
          className={`mobile-navigation-header ${
            isHeaderActive ? "mobile-active" : ""
          }`}
        >
          <div className="mobile-logo-side">
            <div className="agent-pixel-logo" onClick={scrollToTop}>
              <img src={aiAviatorLogo} alt="ai-aviator-logo" />
            </div>
          </div>
          <div
            className={`mobile-hamburger ${
              isMenuActive ? "is-activeHamburger" : ""
            }`}
            onClick={() => setIsMenuActive(!isMenuActive)}
            ref={hamburgerRef}
          >
            <div className="hamburger" id="hamburger-6">
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </div>
        </div>
        <nav
          className={`mobile-menu ${isMenuActive ? "mobile-menu-active" : ""}`}
        >
          <ul id="redirection-links" ref={menuRef}>
            {["About", "Solution", "ROI", "Features", "Benefits", "FAQ"].map(
              (item, index) => (
                <li key={index} tabIndex={index}>
                  <a
                    href={`#${ids[item]}`}
                    data-target={ids[item]}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(ids[item]);
                      setIsMenuActive(false);
                    }}
                    ref={(el) => el && mobileNavLinks.current.push(el)}
                  >
                    <p>{item}</p>
                  </a>
                </li>
              )
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}
